<div class="row mb-4" [formGroup]="itemGroup">
  <div class="col-md-5 col-lg-3 col-xl-3">
    <div class="view zoom overlay z-depth-1 rounded mb-3 mb-md-0 cart-img-wrapper"
         (click)="lightboxOpen.emit(item.path)" style="cursor:zoom-in">
      <img class="img-fluid w-100" [src]="item.path" [alt]="item.reference">
      <div class="mask rgba-black-slight cart-img-overlay">
        <span class="cart-img-zoom-icon">&#128269;</span>
      </div>
    </div>
  </div>

  <div class="col-md-7 col-lg-9 col-xl-9">
    <div>
      <div class="d-flex justify-content-between">
        <div>
          <h5>
            {{ item.reference }}
            <span *ngIf="isOutOfStock" class="badge-out-of-stock">Épuisé</span>
          </h5>
          <p class="mb-3 text-muted text-uppercase small">
            <strong>{{'PRODUCTS.CATEGORY' | translate}}:</strong>&nbsp;{{ item.category }}
          </p>
          <div class="cart-item__field">
            <span class="cart-item__field-label">{{'PRODUCTS.MODEL' | translate}}</span>
            <span class="cart-item__model-tag">{{'PRODUCTS.UNIQUE_MODEL' | translate}}</span>
          </div>
          <div class="cart-item__field">
            <span class="cart-item__field-label">{{'PRODUCTS.SIZES' | translate}}</span>
            <div class="cart-item__size-pills">
              @for (s of sizes; track s) {
                <button type="button"
                        class="cart-item__size-pill"
                        [class.cart-item__size-pill--active]="itemGroup.get('size')?.value === s.value"
                        (click)="setSizeForItem(s.value)">{{ s.label }}</button>
              }
            </div>
          </div>
        </div>

        <div>
          <div class="cart-item__qty">
            <button type="button" (click)="onStepDown()" class="cart-item__qty-btn">−</button>
            <input class="cart-item__qty-input" type="number" formControlName="quantity">
            <button type="button" (click)="onStepUp()" class="cart-item__qty-btn">+</button>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <button type="button" (click)="remove.emit()" class="cart-item__remove">
          <i class="fas fa-trash-alt"></i>
          <span>{{'PRODUCTS.REMOVE' | translate}}</span>
        </button>
        <p class="mb-0"><strong>{{ itemTotal }}</strong></p>
      </div>
    </div>
    <hr class="mb-4">
  </div>
</div>
